<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Proveedores</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <!-- FILTROS -->
      <div class="row">
        <div class="col-md-12 mb-4">
          <vx-card>
            <h1 class="bold big-title m-0">Listado de <span>proveedores</span>.</h1>
          </vx-card>
        </div>
        <!-- ESTATUS -->
        <div class="col-md-8 mb-4">
          <vx-card>
            <h5 class="bold">Orden por estatus</h5>
            <vs-divider></vs-divider>
            <div class="row mt-0">
              <div v-if="isMounted" class="col-md-12">
                <div :key="index" class="row" v-for="(lista, index) in handleNewDashboard" sytle="padding-top: 15px"
                  v-on:click="searchByStatus(lista.statuses)" style="cursor: pointer">
                  <div class="col-md-9">
                    <p class="card-text" :class="lista.class">
                      {{ lista.name }}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <h6 class="card-text" align="right">
                      {{ lista.value }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <!-- RESUMEN Y EXPEDIENTE -->
        <div class="col-md-4 mb-4">
          <vx-card>
            <h5 class="bold">Actualización de expediente</h5>
            <vs-divider></vs-divider>
            <div class="row mt-0">
              <div class="col-md-12">
                <div :key="index" class="row" v-for="(lista, index) in data.data3" sytle="padding-top: 15px"
                  v-on:click="searchByVerified(lista.entry, true)" style="cursor: pointer">
                  <div class="col-md-9">
                    <p class="card-text">
                      {{ lista.verified }}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <h6 class="card-text" align="right">
                      {{ lista.cantidad }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <!-- TABLA -->
      <div class="row mb-4">
        <div class="col-md-12">
          <vx-card>
            <h3 class="bold">Proveedores</h3>
            <!-- BUSCADOR -->
            <div class="row">
              <div class="col-md-11">
                <input type="text" placeholder="Buscar proveedor..." class="form-control" v-model="search"
                  v-on:keyup.enter="searchSupplier()">
                <small>Criterios de busqueda: SID, UID, Nombre, Razón social, Nombre Comercial, Email, Ciudad, Estado,
                  RFC...</small>
              </div>
              <div class="col-md-1">
                <vs-button :disabled="buscando" color="warning" type="filled" icon="search"
                  @click="searchSupplier()"></vs-button>
              </div>
            </div>
            <vs-divider></vs-divider>
            <!-- LISTA -->
            <div class="row">
              <div class="col-md-12">
                <vs-table stripe max-items="15" pagination search :data="suppliers"
                  noDataText="No hay datos disponibles">
                  <template slot="thead">
                    <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                      :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].id">
                        <router-link :to="`/suppliers/${tr.id}`">
                          {{ tr.id }}
                        </router-link>
                      </vs-td>
                      <vs-td>{{ tr.name }}</vs-td>
                      <vs-td>{{ tr.tradename }}</vs-td>
                      <vs-td>{{ tr.representative_name }}</vs-td>
                      <vs-td>{{ tr.email }}</vs-td>
                      <vs-td>{{ phoneFormatDialCode(tr.phone)||"--" }}</vs-td>
                      <vs-td>{{ tr.state||"--" }}</vs-td>
                      <vs-td>{{ tr.city||"--" }}</vs-td>
                      <vs-td>{{ getStatus(tr.status) }}</vs-td>
                      <vs-td>{{ calculateProfileUpdateStatus(tr) }}</vs-td>
                      <vs-td>{{ tr.level}} <br> Recompensa: {{ (tr.award * 100) }}%</vs-td>
                      <vs-td>{{ tr.updated_at | human_date }}</vs-td>
                      <vs-td>{{ tr.created_at | human_date }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import VueApexCharts from 'vue-apexcharts';
import * as moment from 'moment'
import formatHelper from '../../../components/mixins/formatHelper';

const columns = [
  { title: "SID", key: "sid", sortable: true }
  , { title: "Nombre/Razon Social", key: "name", sortable: true }
  , { title: "Nombre Comercial", key: "tradename", sortable: true }
  , { title: "Nombre Repr. Legal", key: "fiscal", sortable: true }
  , { title: "Correo", key: "email", sortable: false }
  , { title: "Teléfono", key: "phone", sortable: false }
  , { title: "Estado", key: "state", sortable: true }
  , { title: "Ciudad", key: "city", sortable: true }
  , { title: "Estatus", key: "status", sortable: false }
  , { title: "Estatus Expediente", key: "update_profile_status", sortable: true }
  , { title: "Nivel I.M.", key: "impacta_mas", sortable: true}
  , { title: "F. Actualización", key: "updated_at", sortable: true }
  , { title: "F. Creación", key: "created_at", sortable: true }
]
export default {
  name: 'suppliers',
  mixins: [formatHelper],
  filters: {
    human_date(date) {
      return moment(date).lang("es").format("D MMM YYYY");
    }
  },
  props: [],
  components: { VueApexCharts },
  async mounted() {
    this.isMounted = false;
    this.showLoading(true);
    axios.get('/api/suppliers').then(response => {
      this.data = response.data;
      this.showLoading(false);
      this.isMounted = true;
    });
    this.handleNewDashboard();
    this.getCollections();
    this.showLoading(false);
  },
  data() {
    return {
      data: [],
      isMounted: false,
      search: '',
      suppliers: [],
      buscando: false,
      columns: columns,
      slas: {
        suppliers_deadline_for_update_profile_days: null
        , suppliers_update_profile_valid_until_days: null
      },
      newOrderData: [],
    }
  },
  computed: {
    handleNewDashboard() {
      return [
        {
          name: "No verificados",
          value: this.data.data[1].cantidad + this.data.data[2].cantidad + this.data.data[3].cantidad,
          class: "bold",
          statuses: [1, 2, 3]
        },
        {
          name: "Instaladores no activados",
          value: this.data.data[1].cantidad,
          class: "",
          statuses: [1]
        },
        {
          name: "Instaladores activados, no verificados",
          value: this.data.data[2].cantidad,
          class: "",
          statuses: [2]
        },
        {
          name: "Instaladores en proceso de verificación",
          value: this.data.data[3].cantidad,
          class: "",
          statuses: [3]
        },
        {
          name: "Verificados (+ Instaladores con solicitud)",
          value: this.data.data[4].cantidad + this.data.data[5].cantidad + this.data.data[6].cantidad + this.data.data[7].cantidad + this.data.data[8].cantidad + this.data.data[9].cantidad,
          class: "bold",
          statuses: [4, 5, 6, 7, 8, 9]
        },
        {
          name: " Verificados, sin proyecto fondeado o sin solicitudes",
          value: this.data.data[4].cantidad,
          class: "",
          statuses: [4]
        },
        {
          name: " Más de 6 meses sin ingresar solicitud",
          value: this.data.data[5].cantidad + this.data.data[6].cantidad,
          class: "",
          statuses: [8, 9]
        },
        {
          name: " De 1 a 6 meses sin ingresar solicitud",
          value: this.data.data[7].cantidad + this.data.data[8].cantidad + this.data.data[9].cantidad,
          class: "",
          statuses: [5, 6, 7]
        },
        {
          name: "Rechazados",
          value: this.data.data[0].cantidad,
          class: "bold",
          statuses: [0]
        },
      ];
    }
  },
  methods: {
    getStatus($status) {
      switch ($status) {
        case 0:
          return 'Rechazados'
        case 1:
          return 'Instaladores no activados';
        case 2:
          return 'Instaladores activados, no verificados';
        case 3:
          return 'Instaladores en proceso de verificación';
        case 4:
          return 'Verificados, sin proyecto fondeado o sin solicitudes';
        case 5:
          return 'De 3 a 6 meses sin ingresar solicitud';
        case 6:
          return 'De 1 a 3 meses sin ingresar solicitud';
        case 7:
          return '1 mes o menos sin ingresar solicitud';
        case 8:
          return 'De 6 a 12 meses sin ingresar solicitud';
        case 9:
          return 'Más de 12 meses sin ingresar solicitud';
        default:
          return 'Indefinido';
      }
    },
    searchByStatus(status) {
      this.showLoading(true);
      axios.post('/api/suppliers/searchByStatus', {
        status: status,
      })
        .then(response => {
          this.suppliers = response.data.suppliers;
          this.showLoading(false);
        });
      this.showLoading(false);
    },
    searchByVerified(verified, isProfileUpdate = false) {
      this.showLoading(true);
      axios.post('/api/suppliers/searchByVerified', {
        verified: verified,
        isProfileUpdate: isProfileUpdate
      })
        .then(response => {
          this.suppliers = response.data.suppliers;
          this.showLoading(false);
        });
      this.showLoading(false);
    },
    searchSupplier() {
      if (this.search != '') {
        this.showLoading(true);
        if (this.buscando == false) {
          this.buscando = true;
          axios.post('/api/suppliers/search2', {
            search: this.search,
          })
            .then(response => {
              this.suppliers = response.data.suppliers;
              this.buscando = false;
              this.showLoading(false);
            }).catch(error => {     
              this.buscando = false;
              this.showLoading(false);
              this.errorNotif("Error al buscar proveedor");
            });
        }
      }
      this.showLoading(false);
    },
    calculateProfileUpdateStatus(supplier) {
      let status = "No definido";
      if (supplier.update_profile_requirement) {
        if (supplier.last_update_profile_requirement_date !== null) {
          if (supplier.update_profile_completed_for_review_date !== null) {
            status = "Pendiente de revisión RG";
          } else {
            let diff = this.differenceBetweenDates(supplier.last_update_profile_requirement_date);
            if (diff > parseInt(this.slas.suppliers_deadline_for_update_profile_days)) {
              status = "Tiempo de actualización excedido";
            } else {
              status = "Actualización en proceso";
            }
          }
        } else {
          status = "Proceso no iniciado";
        }
      } else {
        if (supplier.update_profile_verified_date !== null) {
          status = "Expediente actualizado recientemente";
        } else {
          status = "No se ha solicitado actualización"
        }
      }
      return status;
    },
    differenceBetweenDates(date) {
      let fecha1 = moment(date);
      let fecha2 = moment();
      return fecha2.diff(fecha1, 'days');
    },
    async getCollections() {
      try {
        let slasObjects = ['suppliers_deadline_for_update_profile_days', 'suppliers_update_profile_valid_until_days'];
        let slasParams = "with[]=" + slasObjects.join("&with[]=");
        let slasRes = await axios.get(`/api/v1/forms/getSlasValues?${slasParams}`);
        this.slas = slasRes.data;
      } catch (e) {
        this.warn(e);
      }
    },
    getName(user) {
      if (user.business_profile_id != null) {
        return user.business.name;
      } else {
        const personal = user.personal;
        return personal.first_name + " " + personal.second_name + " " + (personal.last_name_1 ? personal.last_name_1 : "") + " " + (personal.last_name_2 ? personal.last_name_2 : "");
      }
    },
    getRepLegalName(user) {
      if (user.business_profile_id != null) {
        const business = user.business;
        const legalRepresentative = business.personal;
        return legalRepresentative.first_name + " " + legalRepresentative.second_name + " " + (legalRepresentative.last_name_1 ? legalRepresentative.last_name_1 : "") + " " + (legalRepresentative.last_name_2 ? legalRepresentative.last_name_2 : "");
      } else {
        const personal = user.personal;
        return personal.first_name + " " + personal.second_name + " " + (personal.last_name_1 ? personal.last_name_1 : "") + " " + (personal.last_name_2 ? personal.last_name_2 : "");
      }
    },
    getPhone(user) {
      if (user.business_profile_id != null) {
        return `${user.business.phone.country_calling_code} ${this.phoneFormat(user.business.phone.phone)}`;
      } else {
        return `${user.personal.phone.country_calling_code} ${this.phoneFormat(user.personal.phone.phone)}`;
      }
    },
    getAddressState(user) {
      if (user.business_profile_id != null) {
        return user.business.address?.neighborhood_model?.city?.state?.name || "No especificado";
      } else {
        return user.personal.address?.neighborhood_model?.city?.state?.name || "No especificado";
      }
    },
    getAddressCity(user) {
      if (user.business_profile_id != null) {
        return user.business.address?.neighborhood_model?.city?.name || "No especificado";
      } else {
        return user.personal.address?.neighborhood_model?.city?.name || "No especificado";
      }
    },
  }
}
</script>

<style scoped>
h1.big-title>span {
  color: orange !important;
}
</style>
